<div class="toggle-arrow-btn-wrapper" (click)="onClick()">
  <button
    class="toggle-arrow-btn"
    [ngStyle]="{ 'width.px': size, 'height.px': size, opacity: 1 }"
    [attr.aria-label]="ariaLabel"
    [attr.aria-expanded]="expanded"
    [neoTooltip]="expanded ? 'Collapse' : 'Expand'"
    [attr.aut-id]="autId"
    tabindex="0"
  >
    <!-- Use external SVGs -->
    @if (direction === 'left' || direction === 'right') {
    <a360-icon
      [icon]="direction === 'left' ? 'arrow-left' : 'arrow-right'"
      [width]="16"
      [color]="'var(--secondary-text-color)'"
    ></a360-icon>
    }
  </button>
</div>
